import Iframe from "components/iframe";

export default function ClubsIFramePage() {
	return <Iframe url="admin/clubs-amateur" />;
}
